import { 
  getEgresoDropFiles, 
  getEgresoDropFilesByEgreso, 
  uploadEgresoDropFile, 
  updateEgresoDropFile, 
  deleteEgresoDropFile 
} from '../models/egresoDropFilesModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase.js';
import { toasts } from "svelte-toasts";

// Cargar los archivos de un drop específico
export async function fetchEgresoDropFiles(egresoDropId) {
  try {
    const response = await getEgresoDropFiles(egresoDropId, 1, 100);
    return response.items;
  } catch (error) {
    console.error("Error fetching egresoDropFiles:", error);
    Swal.fire('Error', 'No se pudieron cargar los archivos del drop', 'error');
    return [];
  }
}

// Cargar los archivos de todos los drops de un egreso
export async function fetchEgresoDropFilesByEgreso(egresoCabId) {
  try {
    const response = await getEgresoDropFilesByEgreso(egresoCabId, 1, 100);
    return response.items;
  } catch (error) {
    console.error("Error fetching egresoDropFiles by egreso:", error);
    Swal.fire('Error', 'No se pudieron cargar los archivos de los drops', 'error');
    return [];
  }
}

// Subir un nuevo archivo para un drop
export async function saveEgresoDropFile(egresoDropFile, currentFileId) {
  try {
    let result;
    if (currentFileId) {
      result = await updateEgresoDropFile(currentFileId, egresoDropFile);
      toasts.add({
        title: 'Éxito',
        description: 'Archivo del drop actualizado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      result = await uploadEgresoDropFile(egresoDropFile);
      toasts.add({
        title: 'Éxito',
        description: 'Archivo del drop subido exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
    return result;
  } catch (error) {
    console.error("Error saving egresoDropFile:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el archivo del drop',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
    throw error;
  }
}

// Eliminar un archivo de drop
export async function removeEgresoDropFile(id) {
  try {
    await deleteEgresoDropFile(id);
    toasts.add({
      title: 'Éxito',
      description: 'Archivo del drop eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting egresoDropFile:", error);
    Swal.fire('Error', 'No se pudo eliminar el archivo del drop', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'egresoDropFiles'
export function subscribeToEgresoDropFiles(handleSearch) {
  pb.collection('egresoDropFiles').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido en egresoDropFiles:', e);
    await handleSearch(); // Actualiza la lista
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromEgresoDropFiles() {
  pb.collection('egresoDropFiles').unsubscribe('*');
} 